import React from "react";
import "./About.css";

function About() {
  return (
    <>
      <div className="about-page">
        <div className="about">
          <h1 className="about-br">Blackthorn Residential</h1>
          <hr />
          <p>
            Founded in 2021 by Owner Rob Savage, Blackthorn Residential is a
            renovation and new home construction company that specializes in
            upper end renovations and additions. Having spent many years
            building new homes and renovating numerous others for top-tier
            builders, Rob decided to utilize his talents for design and
            innovation for himself and founded the company.
          </p>
          <p>
            Utilizing 3-D CAD for more than twenty years to estimate and
            visualize every project being considered, each project is thoroughly
            analyzed for potential pitfalls and creative solutions to give each
            client a specialized approach to their construction projects. Seeing
            the project come to life in a model allows clients to visualize and
            get excited about what their project will look like when it's
            complete.
          </p>
          <p>
            Whether you are looking to build a new home, renovate a kitchen or
            bathroom, or add a new wing to your existing home, Blackthorn
            Residential is here to make your stressful project stress-free.
          </p>
        </div>
        <div className="diagonal">
          <div className="diag-wrapper">
            <p className="testimonial">
              "In the situation we find ourselves today, it is often difficult
              to find someone who fulfills promises to your expectations. We
              found that someone in Rob Savage. He provided a rendering of the
              finished product, and the final results are spectacular."
            </p>
            <p className="author">- Gary Baskette</p>
          </div>
        </div>
        <div className="about">
          <h1>About Rob</h1>
          <hr />
          <p>
            A graduate of Miami University (OH), Rob worked alongside his
            builder brother and Master Craftsman father in a home renovation
            business during his early years.
          </p>
          <p>
            Following College, Rob spent many years working for a publicly
            traded top 100 builder in the nation. Learning from this proven
            leader established Rob’s understanding of new construction and the
            critical need to schedule each project from start to completion.
            After hundreds of homes built, as well as opening a new market for
            this company in Knoxville, Rob decided to stay in Knoxville and
            raise his family.
          </p>
          <p>
            Rob and his father continued to build and remodel new homes for many
            years in the Knoxville and Tellico Village markets. After many years
            of success, and the retirement of his father, Rob went to work for
            one of the premier builders in the market, working with and for the
            most discerning customers, designers, and architects in the
            Knoxville market. After many years of putting his talents to work
            for others, Rob knew it was time to put his vast knowledge to work
            for himself and his family.
          </p>
          <p>
            Today, Blackthorn Residential and Rob Savage have put their
            attention to detail and focus on quality construction to work
            creating amazing additions and custom renovations for many in the
            Knoxville Market.
          </p>
          <hr />
          <p>
            If you are in need of a custom home, addition, or renovation, please
            consider Blackthorn Residential for your next project.
          </p>
        </div>
      </div>
    </>
  );
}

export default About;
